var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceiptRegister(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12C6.59889 12 6.69556 12.0293 6.77779 12.0843C6.86001 12.1392 6.9241 12.2173 6.96194 12.3087C6.99978 12.4 7.00968 12.5006 6.99039 12.5975C6.9711 12.6945 6.92348 12.7836 6.85355 12.8536C6.78363 12.9235 6.69454 12.9711 6.59755 12.9904C6.50056 13.0097 6.40002 12.9998 6.30866 12.9619C6.2173 12.9241 6.13921 12.86 6.08427 12.7778C6.02933 12.6956 6 12.5989 6 12.5C5.99983 12.4343 6.01264 12.3692 6.0377 12.3085C6.06277 12.2477 6.09959 12.1925 6.14606 12.1461C6.19252 12.0996 6.24771 12.0628 6.30845 12.0377C6.36919 12.0126 6.43429 11.9998 6.5 12Z",
    fill: "#5F6273",
    stroke: "#5F6273",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12C10.5989 12 10.6956 12.0293 10.7778 12.0843C10.86 12.1392 10.9241 12.2173 10.9619 12.3087C10.9998 12.4 11.0097 12.5006 10.9904 12.5975C10.9711 12.6945 10.9235 12.7836 10.8536 12.8536C10.7836 12.9235 10.6945 12.9711 10.5975 12.9904C10.5006 13.0097 10.4 12.9998 10.3087 12.9619C10.2173 12.9241 10.1392 12.86 10.0843 12.7778C10.0293 12.6956 10 12.5989 10 12.5C9.99983 12.4343 10.0126 12.3692 10.0377 12.3085C10.0628 12.2477 10.0996 12.1925 10.1461 12.1461C10.1925 12.0996 10.2477 12.0628 10.3085 12.0377C10.3692 12.0126 10.4343 11.9998 10.5 12",
    stroke: "#5F6273",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12C14.5989 12 14.6956 12.0293 14.7778 12.0843C14.86 12.1392 14.9241 12.2173 14.9619 12.3087C14.9998 12.4 15.0097 12.5006 14.9904 12.5975C14.9711 12.6945 14.9235 12.7836 14.8536 12.8536C14.7836 12.9235 14.6945 12.9711 14.5975 12.9904C14.5006 13.0097 14.4 12.9998 14.3087 12.9619C14.2173 12.9241 14.1392 12.86 14.0843 12.7778C14.0293 12.6956 14 12.5989 14 12.5C13.9998 12.4343 14.0126 12.3692 14.0377 12.3085C14.0628 12.2477 14.0996 12.1925 14.1461 12.1461C14.1925 12.0996 14.2477 12.0628 14.3085 12.0377C14.3692 12.0126 14.4343 11.9998 14.5 12",
    stroke: "#5F6273",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 15H2.2C1.53726 15 1 15.4477 1 16V18C1 18.5523 1.53726 19 2.2 19H17.8C18.4627 19 19 18.5523 19 18V16C19 15.4477 18.4627 15 17.8 15Z",
    stroke: "#5F6273",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7V5",
    stroke: "#5F6273",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H13C12.4477 2 12 2.44772 12 3C12 3.55228 12.4477 4 13 4H15C15.5523 4 16 3.55228 16 3C16 2.44772 15.5523 2 15 2Z",
    fill: "#5F6273",
    stroke: "#5F6273",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 9.125H11.625",
    stroke: "#5F6273",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7H4.15C3.77004 6.99927 3.40387 7.10842 3.12545 7.30542C2.84703 7.50242 2.6771 7.77258 2.65 8.06134L2 15",
    stroke: "#5F6273",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15L17.4222 8.06134C17.3981 7.77258 17.2471 7.50242 16.9996 7.30542C16.7521 7.10842 16.4266 6.99927 16.0889 7L13 7",
    stroke: "#5F6273",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5L8 5.5V9H10V5Z",
    fill: "#5F6273",
    stroke: "#5F6273",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptRegister);
export default __webpack_public_path__ + "static/media/receipt-register.aa5691ed.svg";
export { ForwardRef as ReactComponent };